import React from "react";
import {useNavigate} from "react-router";
import aispFigure from "/assets/aisp-figure.svg?url"
import HeaderItem from "../../components/headerItem/HeaderItem";
import FeatureKey from "../../components/featureKey/FeatureKey";
import {FeatureContainer, FeatureGrid, FeatureKeyTitle} from "../../components/featureKey/FeatureKey.css";
import cardLogo from "/assets/api-card-logo.svg?url";
import StoreItem from "../../components/storeItem/StoreItem";
import {Recommended, SeeAlsoText} from "../../global.css";
import oauth2Logo from "/assets/api-oauth2-logo.svg?url"
import ScrollToTop from "@hooks/scrollToTop";

function Aisp() {
    const navigate = useNavigate()
    return (
        <div>
            <HeaderItem title={"AISP"}
                        description={"L'API AISP (Account Information Service Provider) est une interface de programmation d'application qui permet à des tiers, tels que des agrégateurs financiers ou des applications de gestion financière, d'accéder aux informations de compte d'un utilisateur avec son consentement."}
                        imageUrl={aispFigure}
                        onClick={() => navigate("/aisp/documentation")}>
            </HeaderItem>

            <div className={FeatureKeyTitle}>Fonctionnalités Clés</div>

            <div className={FeatureContainer}>
                <div className={FeatureGrid}>
                    <FeatureKey title={"1"} description1={"Accès aux informations"} description2={"de comptes"}></FeatureKey>
                    <FeatureKey title={"2"} description1={"Récupération"} description2={"de la liste des comptes"}></FeatureKey>
                    <FeatureKey title={"3"} description1={"Récupération"} description2={"des bénéficiaires"}></FeatureKey>
                    <FeatureKey title={"4"} description1={"Récupération"} description2={"de l'identité de l'utilisateur"}></FeatureKey>
                </div>

                <div className={SeeAlsoText}>Nous vous recommandons aussi....</div>
                <div className={Recommended}>
                    <StoreItem
                        title={"PISP"}
                        description={"Prestataires de services d’initiation de paiement"}
                        onClick={() => navigate("/pisp")}
                        imageUrl={cardLogo}>
                    </StoreItem>
                    <StoreItem
                        title={"OAuth2"}
                        description={"Protocole d'autorisation à accès limité aux ressources utilisateur"}
                        onClick={() =>navigate("/oauth2")}
                        imageUrl={oauth2Logo}>
                    </StoreItem>
                </div>

            </div>
            <ScrollToTop />
        </div>


    )
        ;
}

export default Aisp;